(() => {
  const initialize = (root) => {
    root.querySelectorAll('.nmn-header__shop, .nmn-header__dropdown').forEach((menu) => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      const trigger = menu.querySelector('summary');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let closeTimer;
      const open = () => {
        clearTimeout(closeTimer);
        menu.closest('.nmn-header')?.querySelectorAll('.nmn-header__shop, .nmn-header__dropdown').forEach((other) => {
          if (other !== menu) other.open = false;
        });
        menu.open = true;
      };
      menu.addEventListener('toggle', () => {
        if (menu.open) open();
      }, options);
      const close = () => {
        clearTimeout(closeTimer);
        menu.open = false;
      };
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (menu.open) close();
        else open();
      }, options);
      menu.addEventListener('click', (event) => {
        if (!event.target.closest('a[href]')) return;
        close();
        const mobileMenu = menu.closest('.nmn-header__mobile');
        if (mobileMenu) mobileMenu.open = false;
      }, options);
      menu.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !menu.closest('.nmn-header__desktop')) return;
        open();
      }, options);
      menu.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse' || menu.contains(document.activeElement)) return;
        closeTimer = setTimeout(close, 150);
      }, options);
      menu.addEventListener('focusout', (event) => {
        // Keep mobile rows in place until the next tap has activated its target.
        // iOS blurs the summary without focusing the tapped link (relatedTarget is null).
        if (menu.closest('.nmn-header__mobile') && (!event.relatedTarget || menu.closest('nav').contains(event.relatedTarget))) return;
        if (!menu.contains(event.relatedTarget)) close();
      }, options);
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          event.preventDefault();
          event.stopPropagation();
          close();
          trigger.focus();
        }
        if (event.key === 'ArrowDown' && event.target === trigger) {
          event.preventDefault();
          open();
          menu.querySelector('a')?.focus();
        }
      }, options);
      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target)) close();
      }, options);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(menu)) {
          close();
          controller.abort();
        }
      }, options);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
